export default "__VITE_ASSET__CGKOlqVz__"